import i18n from '@/i18n';

export enum TdsFromNextGroup{
  UserInfo = 'userInfo',
  ApplicationInfo = 'applicationInfo',
  DeviceInfo = 'deviceinfo',
  ContextInfo = 'contextInfo',
  ExceptionInfo = 'exceptionInfo',
  Tag = 'tag',
  Custom = 'custom',
  RequestInfo = 'requestInfo',
}
export const COLUMN_GROUP_INFO = {
  [TdsFromNextGroup.UserInfo]: {
    title: i18n.t('用户信息'),
  },
  [TdsFromNextGroup.ApplicationInfo]: {
    title: i18n.t('应用信息'),
  },
  [TdsFromNextGroup.DeviceInfo]: {
    title: i18n.t('设备信息'),
  },
  [TdsFromNextGroup.ContextInfo]: {
    title: i18n.t('现场信息'),
  },
  [TdsFromNextGroup.ExceptionInfo]: {
    title: i18n.t('异常信息'),
  },
  [TdsFromNextGroup.Tag]: {
    title: i18n.t('平台标签'),
  },
  [TdsFromNextGroup.Custom]: {
    title: i18n.t('自定义数据'),
  },
  [TdsFromNextGroup.RequestInfo]: {
    title: i18n.t('请求信息'),
  },
};

